export const COUNTRY_MAPPING = {
    al: 'Albania',
    at: 'Austria',
    ad: 'Andorra',
    be: 'Belgium',
    ba: 'BosniaAndHerzegovina',
    bg: 'Bulgaria',
    hr: 'Croatia',
    cy: 'Cyprus',
    cz: 'CzechRepublic',
    dk: 'Denmark',
    ee: 'Estonia',
    eu: 'EuropeanUnion',
    fi: 'Finland',
    fr: 'France',
    de: 'Germany',
    gr: 'Greece',
    gf: 'France',
    gp: 'France',
    gl: 'Greenland',
    is: 'Iceland',
    ie: 'Ireland',
    il: 'Israel',
    kv: 'Kosovo',
    xk: 'Kosovo',
    lv: 'Latvia',
    lt: 'Lithuania',
    lu: 'Luxembourg',
    md: 'Moldova',
    me: 'Montenegro',
    mk: 'Macedonia',
    mq: 'Martinique',
    mc: 'Monaco',
    no: 'Norway',
    pl: 'Poland',
    pt: 'Portugal',
    re: 'France',
    ro: 'Romania',
    rs: 'Serbia',
    sk: 'Slovakia',
    si: 'Slovenia',
    es: 'Spain',
    ch: 'Switzerland',
    tr: 'Turkey',
    ua: 'Ukraine',
    hu: 'Hungary',
    it: 'Italy',
    se: 'Sweden',
    gb: 'UnitedKingdom',
    nl: 'Netherlands',
};
